import React from "react";
import PropTypes from 'prop-types';

import { BFLoader } from '@components/common/loader/main';
import { pluralizeObject } from '@helpers/show_page_helpers';
import renderModal from '../modals/renderModal';
import AssetAvailability from '../../shared/asset_availability/main';

class BulkAvailabilityModal extends React.Component {
  state = {
    isLoading: false
  }

  componentWillUnmount() {
    this.props.closeModal();
  }

  updateLoading = () => {
    this.setState((prevState) => ({ loading: !prevState.loading }));
  }

  render() {
    const { selectedAssetKeys } = this.props;
    const assetQtyObject = pluralizeObject(selectedAssetKeys);
    const loaderActive = this.state.isLoading ? 'loader-active' : '';
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');

    return (
      <div className="modal-content-wrapper bulk-availability-modal">
        <div className="modal-content-wrapper__header">
          <span className="bff-clock icon" aria-hidden="true" />
          <h2 className="modal-title">{t('Restrict Availability')}</h2>
        </div>
        <div className={`modal-content-wrapper__body ${loaderActive}`}>
          {this.state.isLoading
            ? <BFLoader />
            : (
              <div>
                <h3 className="body-title">{t('Restrict Availability for')}
                  <span className="bold-text">{assetQtyObject.qty} {assetCopy}</span>
                </h3>
                <AssetAvailability
                  activeCdnTracers={this.props.activeCdnTracers}
                  bulk
                  closeModal={this.props.closeModal}
                  selectedAssetKeys={selectedAssetKeys}
                  updateLoading={this.updateLoading}
                />
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

BulkAvailabilityModal.propTypes = {
  activeCdnTracers: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

BulkAvailabilityModal.defaultProps = {
  activeCdnTracers: null,
};

const ModalComponent = renderModal(BulkAvailabilityModal, 'BulkAvailabilityModal');
export default ModalComponent;
